import { Event, EventDispatch } from '../../types'
export * from './Event'

export const dispatch = <T extends Event>(...args: EventDispatch<T>) => {
  const [type, detail] = args

  window.dispatchEvent(new CustomEvent(type, { detail }))
}
